import AppWrapper from "@jumbo/components/AppWrapper";
import React, {useMemo} from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {App} from "@codeArt/apps";
import HomeIcon from "@material-ui/icons/Home";
import {sidebarNavs} from "@jumbo/components/AppLayout/partials/menus";
import ImportantDevicesIcon from "@material-ui/icons/ImportantDevices";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import {requestUrl} from "@codeArt/utils/url";
import {Request, RequestConfig} from "@codeArt/request";
import {Principal} from "@codeArt/auth";
import {useDispatch} from "react-redux";
import {main} from "project/constant/host";
import SettingsIcon from "@material-ui/icons/Settings";
import DashboardIcon from '@material-ui/icons/Dashboard';
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {go} from "@codeArt/apps/app";
import lazy from "@codeArt/apps/lazy";


const Main = ({match}) => {
  const dispatch = useDispatch();
  const matchUrl = requestUrl(match);

  const layout = {
    sidebar:{hidden:true},
    footer: {hidden: true}
  };

  const routes = [
    {
      path: `${matchUrl}/home`,
      component: lazy(() => import("./home")),
      default: true
    }
  ];

  const init = success => {
    success();
  };

  return (
    <App
      name="main"
      request={{domain: main}}
      routes={routes}
      getLayout={() => layout}
      init={init}
      dispatch={dispatch}
    />
  );
};

export default Main;
